/* eslint-disable import/no-webpack-loader-syntax */

// ATENCIÓN: Este archivo es auto-generado. No lo edites manualmente.
export const newslettersMeta = [
  {
    "slug": "20250919_Bashar - 15 Minutos y Contando - Conceptos",
    "title": "Descubre los Secretos de la Co-Creación: Tu Poder Interior.",
    "campaign": "meta",
    "date": "2025-09-19"
  },
  {
    "slug": "20250912_Bashar - 15 Minutos y Contando - Cerebro",
    "title": "Tu Cerebro: La Antena que Recablea Tu Realidad en 15 Minutos.",
    "campaign": "meta",
    "date": "2025-09-12"
  },
  {
    "slug": "20250905_9 Niveles de Conciencia",
    "title": "El mapa de tu mente (y por qué lo leemos al revés).",
    "campaign": "meta",
    "date": "2025-09-05"
  },
  {
    "slug": "20250829_The Formula",
    "title": "La Fórmula de 5 pasos para que todo fluya a tu favor.",
    "campaign": "meta",
    "date": "2025-08-29"
  },
  {
    "slug": "20250822_Realidades Paralelas",
    "title": "No estás a merced de las circunstancias (y aquí te explico por qué).",
    "campaign": "meta",
    "date": "2025-08-22"
  },
  {
    "slug": "20250815_Beneficios de las Leyes",
    "title": "No estás a merced de las circunstancias (y aquí te explico por qué).",
    "campaign": "meta",
    "date": "2025-08-15"
  },
  {
    "slug": "20250808_Villain Within",
    "title": "El saboteador interno: ¿qué lobo estás alimentando?",
    "campaign": "dean",
    "date": "2025-08-08"
  },
  {
    "slug": "20250808_Las 5 Leyes",
    "title": "Las 5 leyes que (en secreto) gobiernan tu realidad.",
    "campaign": "meta",
    "date": "2025-08-08"
  },
  {
    "slug": "20250728_Deep Why",
    "title": "¿Por qué lo hacés? La pregunta que te vuelve imparable.",
    "campaign": "dean",
    "date": "2025-07-28"
  },
  {
    "slug": "20250721_Obten Claridad",
    "title": "Una Mirada Desde el Futuro: El ejercicio que lo cambia todo.",
    "campaign": "dean",
    "date": "2025-07-21"
  },
  {
    "slug": "20250715_Donde estas",
    "title": "¿Dónde estás en este momento de tu vida?",
    "campaign": "dean",
    "date": "2025-07-15"
  },
  {
    "slug": "20250707_Vision Clara",
    "title": "¿Tenés una visión clara o solo acelerás sin rumbo?",
    "campaign": "dean",
    "date": "2025-07-07"
  },
  {
    "slug": "20250701_El Fundamento de Todo Exito",
    "title": "El Fundamento de Todo Éxito",
    "campaign": "dean",
    "date": "2025-07-01"
  }
];

export const loadNewsletterContent = (campaign, slug) => {
  switch (campaign) {
    case 'bashar':
      switch (slug) {
        default: return Promise.reject(new Error('Newsletter not found'));
      }
    case 'dean':
      switch (slug) {
        case '20250808_Villain Within':
          return import('raw-loader!./assets/emails/newsletter/campaigns/dean/20250808_Villain Within.html');
        case '20250728_Deep Why':
          return import('raw-loader!./assets/emails/newsletter/campaigns/dean/20250728_Deep Why.html');
        case '20250721_Obten Claridad':
          return import('raw-loader!./assets/emails/newsletter/campaigns/dean/20250721_Obten Claridad.html');
        case '20250715_Donde estas':
          return import('raw-loader!./assets/emails/newsletter/campaigns/dean/20250715_Donde estas.html');
        case '20250707_Vision Clara':
          return import('raw-loader!./assets/emails/newsletter/campaigns/dean/20250707_Vision Clara.html');
        case '20250701_El Fundamento de Todo Exito':
          return import('raw-loader!./assets/emails/newsletter/campaigns/dean/20250701_El Fundamento de Todo Exito.html');
        default: return Promise.reject(new Error('Newsletter not found'));
      }
    case 'meta':
      switch (slug) {
        case '20250919_Bashar - 15 Minutos y Contando - Conceptos':
          return import('raw-loader!./assets/emails/newsletter/campaigns/meta/20250919_Bashar - 15 Minutos y Contando - Conceptos.html');
        case '20250912_Bashar - 15 Minutos y Contando - Cerebro':
          return import('raw-loader!./assets/emails/newsletter/campaigns/meta/20250912_Bashar - 15 Minutos y Contando - Cerebro.html');
        case '20250905_9 Niveles de Conciencia':
          return import('raw-loader!./assets/emails/newsletter/campaigns/meta/20250905_9 Niveles de Conciencia.html');
        case '20250829_The Formula':
          return import('raw-loader!./assets/emails/newsletter/campaigns/meta/20250829_The Formula.html');
        case '20250822_Realidades Paralelas':
          return import('raw-loader!./assets/emails/newsletter/campaigns/meta/20250822_Realidades Paralelas.html');
        case '20250815_Beneficios de las Leyes':
          return import('raw-loader!./assets/emails/newsletter/campaigns/meta/20250815_Beneficios de las Leyes.html');
        case '20250808_Las 5 Leyes':
          return import('raw-loader!./assets/emails/newsletter/campaigns/meta/20250808_Las 5 Leyes.html');
        default: return Promise.reject(new Error('Newsletter not found'));
      }
    case 'test':
      switch (slug) {
        default: return Promise.reject(new Error('Newsletter not found'));
      }
    case 'test2.1':
      switch (slug) {
        default: return Promise.reject(new Error('Newsletter not found'));
      }
    case 'test2.2':
      switch (slug) {
        default: return Promise.reject(new Error('Newsletter not found'));
      }
    case 'the_code_of_the_extraordinary_mind_100':
      switch (slug) {
        default: return Promise.reject(new Error('Newsletter not found'));
      }
    default: return Promise.reject(new Error('Campaign not found'));
  }
};
